<template>
  <div class="koneko-month-nav" role="group" aria-label="Budget month">
    <v-btn
      icon
      large
      class="koneko-month-nav__arrow"
      aria-label="Previous month"
      @click="$emit('prev')"
    >
      <v-icon large>mdi-chevron-left</v-icon>
    </v-btn>
    <div class="koneko-month-nav__center">
      <div class="koneko-month-nav__title">{{ title }}</div>
      <div v-if="showThisMonthHint" class="koneko-month-nav__hint caption">
        This month
      </div>
    </div>
    <v-btn
      icon
      large
      class="koneko-month-nav__arrow"
      aria-label="Next month"
      @click="$emit('next')"
    >
      <v-icon large>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "KonekoAMonthNavigator",
  props: {
    title: {type: String, required: true},
    showThisMonthHint: {type: Boolean, default: false},
  },
};
</script>

<style scoped>
.koneko-month-nav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  margin: 12px 0 8px;
  max-width: 100%;
}

.koneko-month-nav__center {
  text-align: center;
  min-width: 12rem;
  padding: 0 8px;
}

.koneko-month-nav__title {
  font-size: 1.75rem;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: rgba(0, 0, 0, 0.87);
}

.koneko-month-nav__hint {
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.54);
}

.koneko-month-nav__arrow {
  flex-shrink: 0;
}
</style>
